function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { assign, merge } from 'lodash';
export var initialStateDefault = {
  // Referrals being constructed to be sent
  referrals: [],
  // Referral originating from Assistance Request
  assistanceRequestId: null,
  // Form submissions responses from the Supporting Info step
  formResponses: null,
  // These values are set for draft referrals
  draftState: null,
  selectedProgramsDraft: null,
  // These values must be set from the parent apps before navigating to the flow
  // Programs with services needed to create the referrals
  selectedPrograms: null,
  // Person attached to the referral
  person: null,
  // This values are being set as a prop from the parent app, e.g <AppReferrals appState={{ currentProvider: ...}} />
  currentProvider: null,
  currentEmployee: null,
  enums: null,
  // used as query params for Search App
  resourceListId: null,
  formSubmissionId: null,
  serviceIds: null,
  // "emr" or "app-client"
  // currently used for the share event
  source: null,
  // Referrals originating from screenings 2.0
  screeningId: null
};
export default function StateReducer(state, action) {
  switch (action.type) {
    case 'set':
      {
        return assign(_objectSpread({}, state), _objectSpread({}, action.data));
      }
    case 'merge':
      {
        return merge(_objectSpread({}, state), _objectSpread({}, action.data));
      }
    case 'init':
      {
        return _objectSpread(_objectSpread({}, initialStateDefault), action.data);
      }
    default:
      {
        return state;
      }
  }
}
//# sourceMappingURL=state.js.map